import {useSection} from "../Section/useSection";

export const useBackgroundColor = ({sectionId, containerId}) => {
    const section = useSection(sectionId)

    return section?.containers[containerId]?.backgroundColor || section.backgroundColor
}